import React from 'react';
import { CTABand } from '../../components/CTABand';
export function ScheduleFinalCTA() {
  return <CTABand headline="Questions About the Schedule?" copy="Give us a call and we'll help you find the perfect class time for your family." data-id="element-2951" />;
}